import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { BRAND_COLORS } from "../lib/bookingStatus";
import { useAuth } from "../lib/auth";

// 22 Sep 2026 · App-eigener Splash: statisches Logo (keine Dreh-Animation).
// Blendet sich aus, sobald der initiale Auth-/Datencheck steht (checking=false),
// ohne künstliche Mindestdauer. Ein dezenter Ladeindikator erscheint erst nach
// ~800 ms, falls dann noch geladen wird — bei schnellem Start nie sichtbar.
export default function SplashScreen() {
  const { checking } = useAuth();
  const [visible, setVisible] = useState(true);
  const [fadingOut, setFadingOut] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowLoader(true), 800);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (checking || fadingOut) return;
    setFadingOut(true);
    const t = setTimeout(() => setVisible(false), 280);
    return () => clearTimeout(t);
  }, [checking, fadingOut]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-6"
      data-testid="splash-screen"
      data-phase={fadingOut ? "fading" : "showing"}
      style={{
        background: BRAND_COLORS.navy,
        opacity: fadingOut ? 0 : 1,
        pointerEvents: fadingOut ? "none" : "auto",
        transition: "opacity 280ms ease",
      }}
      aria-hidden="true"
    >
      <img
        src="/weissblom-logo.webp"
        alt="Weissblom"
        data-testid="splash-logo"
        className="w-40 h-40 md:w-48 md:h-48"
        style={{ objectFit: "contain" }}
        decoding="sync"
        fetchPriority="high"
      />
      {showLoader && !fadingOut && (
        <div
          data-testid="splash-loader"
          className="flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase"
          style={{ color: BRAND_COLORS.gold, animation: "wbSplashLoaderIn 300ms ease-out both" }}
        >
          <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={1.8} />
          <span>Wird geladen …</span>
        </div>
      )}
      <style>{`@keyframes wbSplashLoaderIn { from { opacity: 0; } to { opacity: 1; } }`}</style>
    </div>
  );
}
